<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="实际承运人撤单" name="Driver">
        <Driver v-if="isDriverShow" ref="DriverRef" />
      </el-tab-pane>
      <el-tab-pane label="托运人撤单" name="Shipper">
        <Shipper v-if="isShipperShow" ref="ShipperRef" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Driver from "./components/Driver.vue";
import Shipper from "./components/Shipper.vue";
export default {
  components: {
    Driver,
    Shipper
  },
  data() {
    return {
      isDriverShow: true,
      isShipperShow: false,
      activeName: "Driver"
    };
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
    }
  }
};
</script>
